module.exports = __webpack_public_path__ + "img/google-plus.fe91f49b.svg";